<script src="http://maps.googleapis.com/maps/api/js?key=AIzaSyAjUwihU6mKUymVyfAl3pbo3bjIzVhq0WI&libraries=places"></script>
<p-toast #mainGrowl [position]="toastPosition"></p-toast>

<div class="layout-wrapper" [ngClass]="{ 'layout-compact': layoutCompact }">
  <div
    #layoutContainer
    class="layout-container"
    [ngClass]="{
      'menu-layout-static': !isOverlay(),
      'menu-layout-overlay': isOverlay(),
      'layout-menu-overlay-active': overlayMenuActive,
      'menu-layout-horizontal': isHorizontal(),
      'layout-menu-static-inactive': staticMenuDesktopInactive,
      'layout-menu-static-active': staticMenuMobileActive
    }"
  >
    <app-topbar></app-topbar>

    <div
      class="layout-menu"
      [ngClass]="{ 'layout-menu-dark': darkMenu }"
      (click)="onMenuClick($event)"
    >
      <div #layoutMenuScroller class="nano">
        <div class="nano-content menu-scroll-content no-outline">
          <!--<inline-profile *ngIf="profileMode=='inline'&&!isHorizontal()"></inline-profile>-->
          <app-menu [reset]="resetMenu"></app-menu>
        </div>
      </div>
    </div>

    <div class="layout-main" style="margin-bottom: 10px">
      <notification-banner></notification-banner>
      <router-outlet></router-outlet>
    </div>

    <div class="layout-mask"></div>
  </div>
</div>
<div
  *ngIf="settingsReady && enableLiveChat"
  id="dx_chatbot_fab_wrapper_id"
  style="
    background-color: #29567f;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    height: 56px;
    overflow: hidden;
    padding: 12px;
    width: 56px;
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 123;
  "
>
  <img
    [attr.data-dxchannelid]="dialpadSettings.liveChatChannelId"
    [attr.data-dxprovemail]="dialpadSettings.liveChatEmail"
    id="dx_chatbot_fab_id"
    src="https://eu-west.dx.dialpad.com/kpd-static/providers/42943484/webchat/0ec4a0e18728430b8b0f4871332d0ba1/images/fab-icon.png"
    style="clip-path: circle(50%); object-fit: contain; height: auto; width: 100%"
  />
</div>
